import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=5a10b52c&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=5a10b52c&prod&scoped=true&lang=css&"
import style1 from "../../../vab/styles/index/index_big.css?vue&type=style&index=1&id=5a10b52c&prod&scoped=true&lang=css&"
import style2 from "../../../vab/styles/index/index_mid.css?vue&type=style&index=2&id=5a10b52c&prod&scoped=true&lang=css&"
import style3 from "../../../vab/styles/index/index_small.css?vue&type=style&index=3&id=5a10b52c&prod&scoped=true&lang=css&"
import style4 from "./Index.vue?vue&type=style&index=4&id=5a10b52c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a10b52c",
  null
  
)

export default component.exports